export const REJECTED_PREFIX = 'Rejected:';
export const NOT_FOUND_PREFIX = 'Not found:';
